import { createSlice } from "@reduxjs/toolkit";

const defaultState = {
  All_Leads: [
    "Lead Name",
    "leadsid",
    "Lead Owner",
    "Ekyc stage",
    "Lead Stage",
    "Outsourced Team",
    "Created On",
    "Modified On",
    "Aappsflyer id",
    "Phone Number",
    "Lead Source",
  ],

  Agent_Referral: [
    "Lead Name",
    "Created On",
    "Modified On",
    "Call Back Date Time",
    "Ekyc stage",
    "Lead Stage",
    "eKYC Stage Code",
    "Lead Age",
    "LS Disposition",
    "Sub Disposition",
    "1st Connect Call Duration ",
  ],

  Unattempted_Leads: [
    "Lead Name",
    "leadsid",
    "Lead Owner",
    "Ekyc stage",
    "Lead Stage",
    "Outsourced Team",
    "Created On",
    "Modified On",
    "Aappsflyer id",
    "Phone Number",
    "Lead Source",
  ],

  Margin_Not_Added: [
    "Lead Name",
    "Lead Stage",
    "Created On",
    "Modified On",
    "transition e15_Activated",
    "Lead Priority",
    "Ekyc stage",
    "eKYC Stage Code",
    "LS Disposition",
    "Sub Disposition",
  ],

  FnO_Not_Activated: [
    "Lead Name",
    "Lead Stage",
    "Call Back Date Time",
    "Created On",
    "Modified On",
    "Ekyc stage",
    "eKYC Stage Code",
    "Lead Age",
    "LS Disposition",
    "Sub Disposition",
    "Lead Priority",
  ],

  Today_Call_Backs: [
    "Lead Name",
    "Lead Stage",
    "Call Back Date Time",
    "Created On",
    "Modified On",
    "Ekyc stage",
    "eKYC Stage Code",
    "Lead Age",
    "LS Disposition",
    "Sub Disposition",
    "Lead Priority",
  ],

  EKYC_Modified_Leads: [
    "Lead Name",
    "leadsid",
    "Lead Owner",
    "Ekyc stage",
    "Lead Stage",
    "Outsourced Team",
    "Created On",
    "EKYC Modification Date",
    "Aappsflyer id",
    "Phone Number",
    "Lead Source",
  ],

  // "Esign_&_Not_Activated": [
  //   "Lead Name",
  //   "Ekyc stage",
  //   "Created On",
  //   "Modified On",
  //   "Last Attempt",
  //   "Last Connect",
  // ],
};

const initialState = {
  All_Leads: [
    "Lead Name",
    "leadsid",
    "Lead Owner",
    "Ekyc stage",
    "Lead Stage",
    "Outsourced Team",
    "Created On",
    "Modified On",
    "Aappsflyer id",
    "Phone Number",
    "Lead Source",
  ],
  Agent_Referral: [
    "Lead Name",
    "Created On",
    "Modified On",
    "Call Back Date Time",
    "Ekyc stage",
    "Lead Stage",
    "eKYC Stage Code",
    "Lead Age",
    "LS Disposition",
    "Sub Disposition",
    "1st Connect Call Duration ",
  ],
  Unattempted_Leads: [
    "Lead Name",
    "leadsid",
    "Lead Owner",
    "Ekyc stage",
    "Lead Stage",
    "Outsourced Team",
    "Created On",
    "Modified On",
    "Aappsflyer id",
    "Phone Number",
    "Lead Source",
  ],
  Margin_Not_Added: [
    "Lead Name",
    "Lead Stage",
    "Created On",
    "Modified On",
    "transition e15_Activated",
    "Lead Priority",
    "Ekyc stage",
    "eKYC Stage Code",
    "LS Disposition",
    "Sub Disposition",
  ],
  FnO_Not_Activated: [
    "Lead Name",
    "Lead Stage",
    "Call Back Date Time",
    "Created On",
    "Modified On",
    "Ekyc stage",
    "eKYC Stage Code",
    "Lead Age",
    "LS Disposition",
    "Sub Disposition",
    "Lead Priority",
  ],
  Today_Call_Backs: [
    "Lead Name",
    "Lead Stage",
    "Call Back Date Time",
    "Created On",
    "Modified On",
    "Ekyc stage",
    "eKYC Stage Code",
    "Lead Age",
    "LS Disposition",
    "Sub Disposition",
    "Lead Priority",
  ],
  EKYC_Modified_Leads: [
    "Lead Name",
    "leadsid",
    "Lead Owner",
    "Ekyc stage",
    "Lead Stage",
    "Outsourced Team",
    "Created On",
    "EKYC Modification Date",
    "Aappsflyer id",
    "Phone Number",
    "Lead Source",
  ],
  // "Esign_&_Not_Activated": [
  //   "Lead Name",
  //   "Ekyc stage",
  //   "Created On",
  //   "Modified On",
  //   "Last Attempt",
  //   "Last Connect",
  // ],
};

export const smartViewColumnSlice = createSlice({
  name: "smartViewColumn",
  initialState,
  reducers: {
    setSmartViewColumns: (state, action) => {
      const { forTab, columns } = action.payload;
      switch (forTab) {
        case "All_Leads":
          state.All_Leads = columns;
          break;
        case "Agent_Referral":
          state.Agent_Referral = columns;
          break;
        case "Unattempted_Leads":
          state.Unattempted_Leads = columns;
          break;
        case "Margin_Not_Added":
          state.Margin_Not_Added = columns;
          break;
        case "FnO_Not_Activated":
          state.FnO_Not_Activated = columns;
          break;
        case "Today_Call_Backs":
          state.Today_Call_Backs = columns;
          break;
        case "EKYC_Modified_Leads":
          state.EKYC_Modified_Leads = columns;
          break;
        // case "Esign_&_Not_Activated":
        //   state["Esign_&_Not_Activated"] = columns;
        //   break;
        default:
          break;
      }
    },
    setDefaultSmartViewColumns: (state, action) => {
      const { forTab } = action.payload;
      switch (forTab) {
        case "All_Leads":
          state.All_Leads = defaultState.All_Leads;
          break;
        case "Agent_Referral":
          state.Agent_Referral = defaultState.Agent_Referral;
          break;
        case "Unattempted_Leads":
          state.Unattempted_Leads = defaultState.Unattempted_Leads;
          break;
        case "Margin_Not_Added":
          state.Margin_Not_Added = defaultState.Margin_Not_Added;
          break;
        case "FnO_Not_Activated":
          state.FnO_Not_Activated = defaultState.FnO_Not_Activated;
          break;
        case "Today_Call_Backs":
          state.Today_Call_Backs = defaultState.Today_Call_Backs;
          break;
        case "EKYC_Modified_Leads":
          state.EKYC_Modified_Leads = defaultState.EKYC_Modified_Leads;
          break;
        // case "Esign_&_Not_Activated":
        //   state["Esign_&_Not_Activated"] =
        //     defaultState["Esign_&_Not_Activated"];
        //   break;
        default:
          break;
      }
    },
  },
});

export const { setSmartViewColumns, setDefaultSmartViewColumns } =
  smartViewColumnSlice.actions;
export default smartViewColumnSlice.reducer;
